import { Box, Flex } from '@chakra-ui/react';
import {
  floatFormatter,
  intEuroFormatter,
} from 'src/components/molecules/DataTable/cellFuncs';
import { Optimization } from 'src/features/MO/types';
import { useTableEffectFormatter } from 'src/hooks/useEffectFormatter';

import { Icon } from 'src/components/atoms/Icon';

type OptimizationRowProps = {
  optimization: Optimization;
  isExpanded: boolean;
};

export const OptimizationRow: React.FC<OptimizationRowProps> = ({
  optimization,
  isExpanded,
}) => {
  const effectFormatter = useTableEffectFormatter();

  return (
    <Flex
      textAlign={{ lg: 'right', xl: 'left' }}
      whiteSpace={{ base: 'normal', md: 'nowrap' }}
      flex={1}
      flexDir={{ base: 'column', md: 'row' }}
      wrap={{ base: 'wrap', md: 'nowrap' }}>
      <Box
        width={{ base: '100%', md: '15%' }}
        minW={{ base: '120px', md: 'auto' }}
        p={4}
        // textAlign={{ lg: 'right', xl: 'left' }}
        fontSize={{ md: 'xs', lg: 'sm' }}
        fontFamily="marketingPage"
        color="text.title">
        <Icon iconName={isExpanded ? 'chevron-down' : 'chevron-right'} mr={2} />
        {optimization.optimizationName}
      </Box>
      <Box
        width={{ base: '100%', md: '20%' }}
        minW={{ base: '100px', md: 'auto' }}
        p={4}
        textAlign={{ lg: 'right', xl: 'left' }}
        fontSize={{ md: 'xs', lg: 'sm' }}
        fontFamily="marketingPage"
        color="text.title">{`${optimization.period.from.format(
        'YYYY-MM-DD',
      )} - ${optimization.period.to.format('YYYY-MM-DD')}`}</Box>
      <Box
        width={{ base: '50%', md: '15%' }}
        minW={{ base: '80px', md: 'auto' }}
        p={4}
        textAlign={{ lg: 'right', xl: 'left' }}
        fontSize={{ md: 'xs', lg: 'sm' }}
        fontFamily="marketingPage"
        color="text.title">
        {intEuroFormatter(optimization.optimizedInvestmentSum)}
      </Box>
      <Box
        width={{ base: '50%', md: '15%' }}
        minW={{ base: '80px', md: 'auto' }}
        p={4}
        textAlign={{ lg: 'right', xl: 'left' }}
        fontSize={{ md: 'xs', lg: 'sm' }}
        fontFamily="marketingPage"
        color="text.title">
        {effectFormatter(optimization.optimizedEffectSum)}
      </Box>
      {optimization.totalRomi && (
        <Box
          width={{ base: '50%', md: '10%' }}
          minW={{ base: '60px', md: 'auto' }}
          p={4}
          textAlign={{ lg: 'right', xl: 'left' }}
          fontSize={{ md: 'xs', lg: 'sm' }}
          fontFamily="marketingPage"
          color="text.title">
          {floatFormatter(optimization.totalRomi.optimized)}
        </Box>
      )}
      <Box
        width={{ base: '50%', md: '10%' }}
        minW={{ base: '60px', md: 'auto' }}
        p={4}
        textAlign={{ lg: 'right', xl: 'left' }}
        fontSize={{ md: 'xs', lg: 'sm' }}
        fontFamily="marketingPage"
        color="text.title">
        {floatFormatter(optimization.totalRoi.optimized)}
      </Box>
      <Box
        width={{ base: '50%', md: '5%' }}
        minW={{ base: '40px', md: 'auto' }}
        p={4}
        textAlign={{ lg: 'right', xl: 'left' }}
        fontSize={{ md: 'xs', lg: 'sm' }}
        fontFamily="marketingPage"
        color="text.title">
        {optimization.constraints.length}
      </Box>
    </Flex>
  );
};
